/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.30",
    versionName: "0.3.0-nightly.2026.5.30",
    versionChannel: "nightly",
    buildDate: "2026-05-30T00:34:28.662Z",
    commitHash: "7b06deb82983ccb1e4e243518b223d12195c282e",
};
